/* ============================================================
   Breathing room above the footer.

   Marks the LAST SECTION THAT ACTUALLY RENDERS with .wy-foot-lead, so
   wythout-footer.css can pad its own background box. The space then takes
   that section's colour: a full-bleed green CTA grows into the green
   footer, a cream band ends on a clean edge, and a plain white page gets
   plain white space.

   Why JS rather than `:last-child`. Pages routinely end on a section that
   renders nothing — a disabled Yotpo gallery (a bare comment node), or the
   `apps` host both generated PDPs keep for an app block that isn't placed
   yet. `:last-child` selects those, and padding a section with no
   background paints the PAGE background: a white stripe between the real
   last band and the footer, which is the exact artefact this exists to
   remove. CSS cannot express "last section that renders something" —
   the empty ones have no single shape, and testing them needs :has()
   inside :has(), which is invalid CSS and is dropped silently.

   Measuring the rendered box catches every shape at once, and keeps
   working when a merchant adds an app section later.
   ============================================================ */

(function () {
  var CLS = 'wy-foot-lead';

  function apply() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    /* Clear first, then measure. Our own padding gives a previously empty
       section a height, so measuring before clearing would let it qualify
       on every run after the first and walk the marker down the page. */
    var marked = main.getElementsByClassName(CLS);
    while (marked.length) marked[0].classList.remove(CLS);

    var last = null;
    for (var i = 0; i < main.children.length; i++) {
      var el = main.children[i];
      if (el.classList.contains('shopify-section') && el.getBoundingClientRect().height > 0) {
        last = el;
      }
    }
    if (!last) return;

    /* The background lives on the section's root element, not on the
       .shopify-section wrapper — padding the wrapper would paint the page
       background and put the stripe back. Skip <link>/<style>/<script>,
       which the sections emit ahead of their markup and which have no box. */
    for (var j = 0; j < last.children.length; j++) {
      var root = last.children[j];
      if (root.getBoundingClientRect().height > 0) {
        root.classList.add(CLS);
        return;
      }
    }
  }

  var raf;
  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  /* Late arrivals: app widgets (Yotpo) can fill a section after DOMContentLoaded,
     turning a zero-height section into the real last one. */
  window.addEventListener('load', schedule);

  /* A section can be display:none at one breakpoint and visible at another,
     so the last rendered section is width-dependent. */
  window.addEventListener('resize', schedule);

  /* Theme Editor: sections are added, removed and re-rendered in place. */
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
})();
